var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.12234 8.17744L1.08792 8.03767C1.03368 7.81834 1.18126 7.66952 1.96902 6.90217C2.36001 6.52112 2.84674 6.04692 3.23513 5.60493L3.25686 5.58259C3.51839 5.34952 3.75822 5.08363 3.9512 4.86945C4.09993 4.70375 4.22802 4.56293 4.33084 4.47102L4.41018 4.43208C4.10142 4.12837 3.64486 3.69244 3.16433 3.23408C1.03054 1.19853 1.02522 1.18171 1.06277 0.99189L1.12893 0.805L1.26858 0.771064C1.48726 0.717489 1.64927 0.875993 2.47048 1.72675C2.87781 2.1486 3.38422 2.67327 3.87283 3.11372C4.1288 3.39382 4.41765 3.65538 4.65017 3.86567C4.82113 4.02083 4.96776 4.15422 5.06619 4.2602L5.13308 4.38264L5.13406 4.47993L5.12795 4.64802L5.00173 4.72138C4.97514 4.73707 4.94107 4.75071 4.90066 4.7552L4.90554 4.76655L4.79324 4.88703C4.25386 5.46556 3.65596 6.08173 2.9114 6.82526C2.44673 7.29272 1.98123 7.73817 1.52273 8.17573L1.41726 8.2768L1.12234 8.17744Z",
    fill: "#18376D",
    stroke: "#18376D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBtn);
export default __webpack_public_path__ + "static/media/right-btn.94c500641cace0277aec911d9d3c3ce3.svg";
export { ForwardRef as ReactComponent };